export default {

    methods: {

        /**
         * Gets the EPC rating associated with a given SAP score.
         * @param {number} sapScore
         * @returns {string}
         * @private
         */
        getEpcRating(sapScore) {
            if (sapScore >= 92)
                return 'A'
            else if (sapScore >= 81)
                return 'B'
            else if (sapScore >= 69)
                return 'C'
            else if (sapScore >= 55)
                return 'D'
            else if (sapScore >= 39)
                return 'E'
            else if (sapScore >= 21)
                return 'F'

            return 'G'
        },

        /**
         * Gets the SAP change display.
         * @param {string} sapDisplay The display text provided by the metric data.
         * @param {boolean} [longForm=false] An optional flag to include SAPΔ rather than just Δ as a suffix.
         * @returns {string}
         */
        formatSapChangeText(sapDisplay, longForm = false) {
            if (sapDisplay === 'none')
                return longForm ? 'No SAPΔ' : 'No Δ'

            const prefixed = sapDisplay.startsWith('-')
                ? sapDisplay : `+${ sapDisplay }`

            return longForm ? `${ prefixed } SAPΔ` : `${ prefixed }Δ`
        },
    },
}
